// client/src/hooks/usePea.js

import { useState, useCallback } from 'react';
import peaService from '../services/peaService';

const usePea = () => {
  const [overview, setOverview] = useState(null);
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState({
    overview: false,
    accounts: false,
    saving: false,
    importing: false
  });
  const [error, setError] = useState('');

  // Fabrique un appel qui gère le drapeau de chargement et remonte l'erreur.
  const run = useCallback(async (key, fn) => {
    setLoading((prev) => ({ ...prev, [key]: true }));
    setError('');
    try {
      return await fn();
    } catch (err) {
      setError(err.message || 'Une erreur est survenue.');
      throw err;
    } finally {
      setLoading((prev) => ({ ...prev, [key]: false }));
    }
  }, []);

  const fetchOverview = useCallback(
    () =>
      run('overview', async () => {
        const data = await peaService.getOverview();
        setOverview(data);
        setAccounts(data.accounts);
        return data;
      }),
    [run]
  );

  const fetchAccounts = useCallback(
    () =>
      run('accounts', async () => {
        const data = await peaService.getAccounts();
        setAccounts(data);
        return data;
      }),
    [run]
  );

  const addAccount = useCallback(
    (data) => run('saving', () => peaService.createAccount(data)),
    [run]
  );

  const editAccount = useCallback(
    (id, data) => run('saving', () => peaService.updateAccount(id, data)),
    [run]
  );

  const removeAccount = useCallback(
    (id) => run('saving', () => peaService.deleteAccount(id)),
    [run]
  );

  const removePosition = useCallback(
    (id) => run('saving', () => peaService.deletePosition(id)),
    [run]
  );

  const importPortfolio = useCallback(
    (accountId, file) => run('importing', () => peaService.importPortfolio(accountId, file)),
    [run]
  );

  return {
    overview,
    accounts,
    loading,
    error,
    setError,
    fetchOverview,
    fetchAccounts,
    addAccount,
    editAccount,
    removeAccount,
    removePosition,
    importPortfolio
  };
};

export default usePea;
